module.exports = "<iframe [attr.src]=\"url\"></iframe>"